import { useEffect, useState } from 'react'

import { MaintenancePage } from '@/shared/components/MaintenancePage'
import { onMaintenanceMode, type MaintenanceDetail } from '@/shared/lib/maintenanceMode'

/**
 * Listens for the 503 maintenance event emitted by `httpClient` and takes over the
 * whole app (`preventDefault`) with the maintenance page. Mirrors `SessionExpiredModal`.
 */
export function MaintenanceGate() {
  const [detail, setDetail] = useState<MaintenanceDetail | null>(null)

  useEffect(
    () =>
      onMaintenanceMode((event) => {
        event.preventDefault()
        setDetail(event.detail ?? {})
      }),
    [],
  )

  if (!detail) {
    return null
  }

  return <MaintenancePage message={detail.message} retryAfter={detail.retryAfter} />
}
